<template>
   <section class="home-bed">
    <div class="img-bed">
      <black-bar title="常见问题">
      </black-bar>
    </div>
    <div class="cardInfo">
      <img src="../assets/img/noAccess/banner@3x.png"
           alt="" />
      <div class="word">客服咨询</div>
    </div>
    <!-- <ul class="list-box">
      <li class="title">
        <img src="../assets/img/noAccess/icon_normal.png"
             alt="" />
        <span>常见问题</span>
      </li>
      <li
      class="list-li"
      v-for="(item, index) in list"
      :key="index"
      :value="item.id"
      @click="questionDetail(item.id)"
      >
      <span>{{ item.title }}</span>
      <img src="../assets/img/noAccess/btn_back@3x.png"
             alt="" />
      <div class="help-content">
        
      </div>
      </li>
    </ul> -->
    <div class="list-box">
      <div class="title">
        <img src="../assets/img/noAccess/icon_normal.png"
             alt="" />
        <span>常见问题</span>
      </div>
      <van-collapse accordion v-model="activeNames" value="1" bind:change="onChange" @change="collapseOpen">
        <van-collapse-item class="collapse-item" v-for="(item,index) in list" :key="index" :title="item.title" :name="item.id">
          <div class="inHtml" v-html="content">
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
  </section> 
</template>

<script>
import blackBar from '@/components/blackBar'
import { questionList,questionDetail } from '../api/data.js'

export default {
  name: 'questionList',
  data () {
    return {
      loading: true,
      list: [],
      activeNames:[],
      content:{}
    }
  },
  components: {
    blackBar,
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  mounted () {
    console.log('mounted')
    questionList().then(res => {
      if(res.data.code === 200) {
        this.list = JSON.parse(res.data.data);
        console.log(this.list)
      }else {

      }
    })
  },
  methods: {
    collapseOpen(e) {
      const questionId = e
      console.log('questionId===',e)
      if(questionId) {
        this.showQuestionDetail(questionId)
      }
    },
    showQuestionDetail(questionId) {
      questionDetail(questionId).then(res => {
      if(res.data.code === 200) {
        const data = JSON.parse(res.data.data)
        console.log(data)
        this.content = data.content
        console.log(this.src)
      }else {

      }
    })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
  background-color: #f5f5f5;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
.cardInfo {
  width: 92%;
  margin-left: 4%;
  position: relative;
  img {
    width: 100%;
  }
  .word {
    position: absolute;
    top: 50%;
    left: 64px;
    margin-top: -28px;
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 40px;
    font-weight: 500;
    color: #ffffff;
    text-align: left;
  }
}
.collapse {
  display: block;
}
.list-box {
  width: calc(92% - 48px);
  margin-left: 4%;
  padding: 0 24px;
  // height: 430px;
  background: #ffffff;
  border-radius: 16px 16px 16px 16px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  // align-items: center;
  justify-content: center;
  .collapse-item {
    text-align: left;
  }
  .list-li {
    line-height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dcdcdc;
    span {
      font-size: 28px;
      font-weight: 400;
      color: #333333;
    }

    img {
      width: 24px;
      height: 24px;
    }
  }
  li:last-child {
    border-bottom: 0px;
  }
  .title {
    line-height: 88px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    border-bottom: 1px solid #dcdcdc;
    span {
      font-size: 32px;
      font-weight: 500;
      color: #282b29;
      margin-left: 18px;
    }
    img {
      width: 32px;
      height: 32px;
    }
  }
}
</style>

<style>
.inHtml ul {
  list-style: unset;
  /* background-color: #999; */
}
.inHtml ul li {
  /* color: #000; */
  font-size: 28px;
}
</style>
